<template>
    <div class="relative">
        <div v-if="status === 'pending'" class="w-full h-screen">
            <Skeleton class="w-full h-full" />
        </div>
        <div v-else-if="error" class="relative w-full h-screen grid place-items-center bg-primary/10">
            <div class="flex items-center justify-center flex-col gap-4">
                <Icon name="glyphs:image-duo" class="size-48! text-rose-600/50" />
                <p class="text-rose-200 text-sm">Error in getting the image</p>
            </div>
        </div>
        <div v-else-if="banners?.length" class="w-full h-screen">
            <ClientOnly>
                <PageHomeHeroCarousel ref="slider" v-model="currentSlide" :banners />
            </ClientOnly>
            <div class="right-8 bottom-8 z-10 absolute">
                <ul class="flex gap-4">
                    <li
                        v-for="(item, key) in banners"
                        :key
                        class="shadow rounded-lg size-16 lg:size-20 overflow-hidden cursor-pointer"
                        :class="key + 1 === currentSlide ? 'opacity-100 border border-primary' : 'opacity-25'"
                        @click="handleGoToSlide(key)"
                    >
                        <Image :desktop="item.media.image" class="w-full h-full object-cover" preset="thumbnail" />
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="list?.length" class="absolute inset-0">
            <ul class="flex flex-col justify-center gap-8 h-full">
                <li v-for="(item, key) in list" :key class="flex justify-start w-full">
                    <NuxtLink
                        :to="`/categories/${item.slug}`"
                        class="flex justify-center lg:w-1/3 hover:w-[calc(calc(1/3*100%)+2rem)] hover:max-w-[calc(var(--container-2xs)+2rem)] max-w-2xs transition-all duration-300 ease-out"
                    >
                        <Glass
                            blur="xs"
                            class="ltr:rounded-r-2xl rtl:rounded-l-2xl w-full hover:bg-white/85"
                            rounded="none"
                            effect-class="bg-white/50"
                            content-class="max-lg:p-2 justify-center md:justify-end"
                        >
                            <div class="size-16 md:size-28 lg:size-36">
                                <AspectRatio :ratio="1 / 1" class="flex max-md:gap-2 flex-row-reverse md:flex-col justify-center items-center">
                                    <Icon v-if="item.icon" :name="item.icon" class="size-14! lg:size-16! text-accent" />
                                    <Typography tag="h4" variant="subtitle" class="hidden md:block mt-2 text-accent/75">
                                        {{ $t(`category.name.${item.name}`, item.name) }}
                                    </Typography>
                                </AspectRatio>
                            </div>
                        </Glass>
                    </NuxtLink>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Glass } from "@/components/ui/glass";
import { Skeleton } from "@/components/ui/skeleton";
import { AspectRatio } from "@/components/ui/aspect-ratio";

const { data, status, error } = useBanners("homePage");
const { data: categories } = useCategories();

const currentSlide = ref(1);
const slider = useTemplateRef("slider");

const list = computed(() => useFilter(categories.value?.data, (e: APICategory) => e.parent === undefined));
const banners = computed(() => data.value?.data);

function handleGoToSlide(index: number) {
    slider.value?.goToSlide(index);
}
</script>
